import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string";
import FieldToggle from "../../fields3/generic/boolean/toggle/toggle";
import FieldIcon from "../../fields3/generic/icon/icon";
import FieldConfig from "../../fields3/proto/field-config";
import {TASK_ICON_CATEGORIES} from "../../gd/const/item-icon/task-categories";
import {IconType} from "../../gd-components/selector/icon-selector/@const";

const baseConfig: FieldConfig[] = [
    {
        fieldId     : 'name',
        type        : FieldType.STRING,
        label       : 'Name'
    },
    {
        fieldId     : 'icon',
        type        : FieldType.ICON,
        label       : 'Tas type icon',
        fieldParams : {
            iconTypes: [IconType.ITEM_ICONS],
            iconCategories: TASK_ICON_CATEGORIES,
        }
    },
    {
        fieldId     : 'isDefault',
        type        : FieldType.TOGGLE,
        label       : 'Is Default'
    }
]

export default class TaskTypeFields extends FieldsCollection {

    get name(): FieldString         { return this.get('name') as FieldString }
    get icon(): FieldIcon           { return this.get('icon') as FieldIcon }
    get isDefault(): FieldToggle    { return this.get('isDefault') as FieldToggle }

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed
        super(fieldsConfig, EntityType.TASK_TYPE);
    }
}
